
 <!-- 保租房租控 -->
<template>
  <div class="rent-control-container">
    <!-- 顶部汇总统计卡片 -->
    <div class="stat-header">
      <div v-for="(item, index) in summaryCards" :key="index" class="stat-card">
        <div class="stat-label">{{ item.label }}</div>
        <div class="stat-value" :style="{ color: item.color }">
          {{ item.value }} <span class="unit">套</span>
        </div>
      </div>
    </div>

    <!-- 筛选工具栏 -->
    <div class="filter-toolbar">
      <span class="toolbar-label">选择楼栋：</span>
      <el-select
        v-model="selectedBuilding"
        size="small"
        placeholder="请选择"
        style="width: 200px"
        @change="buildingChange"
      >
        <el-option
          v-for="item in floorList"
          :label="item.name"
          :value="item.floorId"
          :key="item.floorId"
        />
      </el-select>
    </div>

    <!-- 图例栏 -->
    <div class="legend-toolbar">
      <span class="legend-title">图例：</span>
      <div v-for="lg in legendList" :key="lg.label" class="legend-item">
        <span
          class="legend-box"
          :style="{
            backgroundColor: lg.bg,
            borderColor: lg.border || 'transparent',
            borderStyle: lg.border ? 'solid' : 'none',
            borderWidth: '1px',
          }"
        ></span>
        <span class="legend-text">{{ lg.label }}</span>
      </div>
    </div>

    <!-- 房源矩阵容器 -->
    <div class="grid-wrapper">
      <div class="room-grid">
        <div
          v-for="room in roomList"
          :key="room.roomId"
          class="room-item"
          :class="[
            room.contract && room.contract.expiring
              ? 'status-expiring'
              : 'status-' + room.state,
          ]"
        >
          {{ room.roomNum }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapState, mapActions, mapMutations } from "vuex";
import { formatDate } from "../../../utils/dateUtil.js";
import {
  mapValuesToArray,
  commonFormatter,
  safeDivide,
} from "../../../utils/tool.js";
import leaseControlMapTab1Modal from "./leaseControlMapTab1Modal.vue";
const TAG = "保租房租控";

export default {
  data() {
    return {
      // 头部统计数据
      summaryCards: [
        {
          label: "总房源数",
          value: "",
          unit: "套",
          color: "#409EFF",
          key: "total",
        },
        {
          label: "已出租",
          value: "",
          unit: "套",
          color: "#67C23A",
          key: "rentedCount",
        },
        {
          label: "空置可租",
          value: "",
          unit: "套",
          color: "#E6A23C",
          key: "availableCount",
        },
        {
          label: "已预订",
          value: "",
          unit: "套",
          color: "#409EFF",
          key: "reservedCount",
        },
        {
          label: "即将到期",
          value: "",
          unit: "套",
          color: "#F56C6C",
          key: "expiringCount",
        },
      ],
      selectedBuilding: "", // 当前选择楼栋
      // 下方图例数据
      legendList: [
        { label: "已出租", bg: "#52c41a" },
        { label: "空置可租", bg: "#ffffff", border: "#dcdfe6" },
        { label: "已预订", bg: "#ffffff", border: "#1890ff" },
        { label: "即将到期", bg: "#f5222d" },
      ],
    };
  },

  computed: {
    ...mapState("asset", ["floorList", "roomTotal", "unitList", "roomList"]),
  },

  mounted() {
    this.init();
    this.initRoomGrid();
  },

  methods: {
    ...mapActions("asset", [
      "queryBuildingRoomChartHandler", // 查询楼栋房间信息（按单元和楼层划分）
      "queryResourceWithAssetHandler", // 查询资源及资产信息（车位、广告、铺位）
      "statisticRoomStatusHandler", // 统计各租赁状态的房间数量
    ]),

    init() {
      const params = { assetCategory: "AFFORDABLE_HOUSING" };
      this.queryBuildingRoomChartHandler(params).then((list) => {
        console.log(TAG, "init list=", list);
        this.selectedBuilding = _.get(this.floorList, "[0].floorId");
        console.log(TAG, "init this.selectedBuilding=", this.selectedBuilding);
        console.log(TAG, "init this.unitList=", this.unitList);
      });

      this.statisticRoomStatusHandler(params).then((obj) => {
        this.summaryCards = mapValuesToArray(this.summaryCards, obj);
        console.log(TAG, "init this.summaryCards=", this.summaryCards);
      });
    },

    buildingChange() {
      this.queryBuildingRoomChartHandler({
        assetCategory: "AFFORDABLE_HOUSING",
        floorId: this.selectedBuilding,
      }).then((res) => {
        console.log(TAG, "buildingChange this.unitList=", this.unitList);
      });
    },

    // 初始化生成房源数据，完全匹配图片中的文字和状态
    initRoomGrid() {
      const rooms = [];
      // 模拟生成的房间号范围从 0101 到 0620
      const floors = ["01", "02", "03", "04", "05", "06"];
      const perFloor = 20;

      floors.forEach((f) => {
        for (let i = 1; i <= perFloor; i++) {
          const roomNo = f + i.toString().padStart(2, "0");
          let status = "vacant"; // 默认状态空置

          // 颜色分布
          const rentedRooms = [
            "0102",
            "0204",
            "0207",
            "0209",
            "0216",
            "0302",
            "0305",
            "0308",
            "0310",
            "0314",
            "0319",
            "0402",
            "0408",
            "0416",
            "0417",
            "0503",
            "0505",
            "0512",
            "0513",
            "0515",
            "0517",
            "0611",
            "0612",
            "0615",
            "0617",
            "0619",
          ];
          const reservedRooms = [
            "0101",
            "0108",
            "0119",
            "0215",
            "0218",
            "0219",
            "0303",
            "0307",
            "0316",
            "0403",
            "0410",
            "0418",
            "0419",
            "0504",
            "0618",
          ];

          if (rentedRooms.includes(roomNo)) {
            status = "rented";
          } else if (reservedRooms.includes(roomNo)) {
            status = "reserved";
          }

          rooms.push({ no: roomNo, status: status });
        }
      });
      // this.roomList = rooms;
    },
  },
};
</script>

<style lang="scss" scoped>
/* 颜色变量定义 */
$bg-main: #f0f2f5; // 页面主背景色
$color-green: #52c41a; // 已出租（绿色）
$color-reserved: #1890ff; // 已预订（蓝色）
$color-white: #ffffff; // 容器背景
$color-red: #f5222d; // 即将到期（红色）
$border-light: #ebeef5; // 浅色分割线
$text-secondary: #909399; // 次要文字颜色

.rent-control-container {
  // padding: 16px;
  // background-color: $bg-main;
  min-height: 100vh;

  /* 顶部统计卡片（一排5个） */
  .stat-header {
    display: flex;
    gap: 12px;
    margin-bottom: 20px;

    .stat-card {
      flex: 1;
      background: #fff;
      padding: 15px 20px;
      border-radius: 4px;
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);

      .stat-label {
        font-size: 13px;
        color: $text-secondary;
        margin-bottom: 8px;
      }
      .stat-value {
        font-size: 24px;
        font-weight: 500;
        .unit {
          font-size: 14px;
          margin-left: 2px;
        }
      }
    }
  }

  /* 筛选工具栏 */
  .filter-toolbar {
    background: #fff;
    padding: 12px 20px;
    border-radius: 4px 4px 0 0;
    border-bottom: 1px solid $border-light;
    text-align: left;
    .toolbar-label {
      font-size: 14px;
      font-weight: bold;
      color: #333;
    }
  }

  /* 图例栏 */
  .legend-toolbar {
    background: #fff;
    padding: 10px 20px;
    display: flex;
    align-items: center;
    gap: 15px;
    border-bottom: 1px solid $border-light;

    .legend-title {
      font-size: 13px;
      font-weight: bold;
    }
    .legend-item {
      display: flex;
      align-items: center;
      gap: 6px;
      .legend-box {
        width: 14px;
        height: 14px;
        border-radius: 2px;
        display: inline-block;
      }
      .legend-text {
        font-size: 12px;
        color: #606266;
      }
    }
  }

  /* 房源矩阵容器 */
  .grid-wrapper {
    background: #fff;
    padding: 30px;
    border-radius: 0 0 4px 4px;
    min-height: calc(100vh - 460px);

    .room-grid {
      display: grid;
      // 对应图片中一排 8 列的效果
      grid-template-columns: repeat(8, 1fr);
      gap: 12px;
      width: 100%;
    }
  }

  /* 房间单项样式 */
  .room-item {
    height: 36px;
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 13px;
    cursor: pointer;
    transition: all 0.2s;
    border: 1px solid transparent;

    /* 状态颜色 */
    // 已经出租
    &.status-2006,
    &.rented {
      background-color: $color-green;
      color: #fff;
      font-weight: bold;
    }

    // 空闲可租
    &.status-AVAILABLE,
    &.status-2001, // 已入住
    &.status-2002, // 未销售
    &.status-2003, // 已交房
    &.status-2005, // 已装修
    &.status-2004, // 未入住
    &.status-2004, // 未入住
    &.status-2007, // 已出售
    &.status-2008, // 空闲
    &.vacant {
      background-color: $color-white;
      border: 1px solid #dcdfe6;
      color: #999;
    }

    // 已预定
    &.reserved {
      background-color: #fff;
      border: 2px solid $color-reserved; // 突出蓝色边框
      color: $color-reserved;
      font-weight: bold;
    }

    // 即将到期
    &.status-expiring {
      background-color: $color-red;
      color: #fff;
    }

    &:hover {
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      opacity: 0.9;
    }
  }
}

/* 响应式适配：根据屏幕宽度动态调整每行显示的方块数 */
@media (max-width: 1400px) {
  .rent-control-container .grid-wrapper .room-grid {
    grid-template-columns: repeat(6, 1fr);
  }
}

@media (max-width: 1100px) {
  .rent-control-container .stat-header {
    flex-wrap: wrap;
    .stat-card {
      min-width: 180px;
    }
  }
  .rent-control-container .grid-wrapper .room-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (max-width: 768px) {
  .rent-control-container .grid-wrapper .room-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>